<template>
  <base-table :data="users" thead-classes="text-primary" v-if="account.user.is('backoffice')">
    <template slot="columns" slot-scope="{ columns }">
      <th class="text-center">#</th>
      <th>Nome</th>
      <th>Cognome</th>
      <th>Ruolo</th>
      <th>Email</th>
      <!-- <th class="text-right">Milestone</th> -->
      <th class="text-right">Azioni</th>
    </template>

    <template slot-scope="{ row, index }" v-if="users.length > 0">
      <td class="text-center lead">
        <div class="photo"> <i class="icon-single-02 tim-icons"></i> </div>
      </td>
      <td >
        <base-input
          v-validate="'required'"
          name="name"
          class="mb-0"
          :error="getError('name')"
          v-model="row.name"
          placeholder="Nome"
        >
        </base-input>
      </td>
      <td>
        <base-input
          class="mb-0"
          v-validate="'required'"
          name="surname"
          :error="getError('surname')"
          v-model="row.surname"
          placeholder="Cognome"
        >
        </base-input>
      </td>
      <td>
        <el-select
          multiple
          class="select-info"
          size="large"
          v-model="row.roles"
          collapse-tags
          placeholder="Seleziona i ruoli"
        >
          <el-option
            v-for="option in roles"
            class="select-info"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          >
          </el-option>
        </el-select>
      </td>
      <!-- <td class="text-center"><base-progress :value="row.progress" /></td> -->
      <td>{{row.email}}</td>
      <td class="text-right">
        <el-tooltip
          content="Salva"
          effect="light"
          :open-delay="300"
          placement="top"
        >
          <base-button
            :type="index > 2 ? 'success' : 'neutral'"
            icon
            @click="update(row)"
            size="sm"
            class="btn-link"
          >
            <i class="tim-icons icon-refresh-01"></i>
          </base-button>
        </el-tooltip>
        <el-tooltip
          content="Cancella"
          effect="light"
          :open-delay="300"
          placement="top"
        >
          <base-button
            :type="index > 2 ? 'danger' : 'neutral'"
            icon
            size="sm"
            class="btn-link"
          >
            <i class="tim-icons icon-simple-remove"></i>
          </base-button>
        </el-tooltip>
      </td>
    </template>
  </base-table>
</template>
<style lang="scss">
  .lead{
    font-size: 16px;
    .photo{
      padding-top: 3px;
      background: rgba(#fff,0.05)
    }
  }
</style>
<script>
import { Select, Option } from 'element-ui';

import { BaseTable /*, BaseProgress*/ } from '@/components';
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    BaseTable,
    // BaseProgress
  },
  computed: {
    ...mapState({
      account: state => state.account,
      users: state => state.users.users.docs,
    })
  },
  created () {
    this.getAll();
  },
  methods: {
    ...mapActions('users', {
      getAll: 'getAll',
      update: 'update',
      delete: 'delete'
    }),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  },
  data(){
    return {
      roles: [{
        value: 'subscriber',
        Label: 'Visitatore',
      },{
        value: 'backoffice',
        Label: 'Amministratore',
      },{
        value: 'worker',
        Label: 'Dipendente',
      }],
    }
  }
};
</script>
<style></style>
